export interface Notifier {
  success(message: string): void
  error(message: string): void
  info?(message: string): void
}

const defaultNotifier: Notifier = {
  success: (message) => console.warn('[notifier] success (no notifier set):', message),
  error: (message) => console.warn('[notifier] error (no notifier set):', message),
  info: (message) => console.warn('[notifier] info (no notifier set):', message),
}

let current: Notifier = defaultNotifier

export function setNotifier(notifier: Notifier): void {
  current = notifier
}

export function getNotifier(): Notifier {
  return current
}
